// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useState } from 'react';
import { Select, MenuItem, InputBase, SelectChangeEvent } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { FILE_SORT_OPTIONS, FileSortMode } from 'Utils/fileSort';
import stylesDef from './styles';

interface FileSortSelectProps {
  value: FileSortMode;
  onChange: (mode: FileSortMode) => void;
}

export const FileSortSelect = ({ value, onChange }: FileSortSelectProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  // Unique per instance so two FileSortSelects on the same page never collide on DOM id -
  // generated once and kept stable across re-renders. React's useId() would be the more
  // conventional choice, but @types/react is pinned below the version that declares it.
  const [inputId] = useState(() => `file-sort-${Math.random().toString(36).slice(2)}`);

  return (
    <Box sx={styles.container}>
      <Box component="span" sx={styles.label}>Sort by</Box>
      <Select
        inputProps={{ name: inputId, id: inputId }}
        input={<InputBase />}
        value={value}
        sx={styles.select}
        onChange={(ev: SelectChangeEvent) => onChange(ev.target.value as FileSortMode)}
      >
        {FILE_SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} sx={styles.menuItem} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default FileSortSelect;
